var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F4E8BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.3701C15.2652 11.3701 15.5196 11.4755 15.7071 11.663C15.8946 11.8505 16 12.1049 16 12.3701V24.3701C16 24.6353 15.8946 24.8897 15.7071 25.0772C15.5196 25.2648 15.2652 25.3701 15 25.3701C14.7348 25.3701 14.4804 25.2648 14.2929 25.0772C14.1054 24.8897 14 24.6353 14 24.3701V12.3701C14 12.1049 14.1054 11.8505 14.2929 11.663C14.4804 11.4755 14.7348 11.3701 15 11.3701ZM21 11.3701C21.2652 11.3701 21.5196 11.4755 21.7071 11.663C21.8946 11.8505 22 12.1049 22 12.3701V24.3701C22 24.6353 21.8946 24.8897 21.7071 25.0772C21.5196 25.2648 21.2652 25.3701 21 25.3701C20.7348 25.3701 20.4804 25.2648 20.2929 25.0772C20.1054 24.8897 20 24.6353 20 24.3701V12.3701C20 12.1049 20.1054 11.8505 20.2929 11.663C20.4804 11.4755 20.7348 11.3701 21 11.3701Z",
    fill: "#D6AE21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldIcon);
export default __webpack_public_path__ + "static/media/holdIcon.71bfd312cc1a3f8208dc061ad8a74c46.svg";
export { ForwardRef as ReactComponent };